import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmWrapWithOrResult, } from "../operation/index.js";
import { DataPsmExecutorResultFactory, loadDataPsmSchema, } from "./data-psm-executor-utils.js";
import { DataPsmOr } from "../model/index.js";
import { replaceObjectInSchema } from "./replace-object-in-schema.js";
export async function executeDataPsmWrapWithOr(reader, createNewIdentifier, operation) {
    const schema = await loadDataPsmSchema(reader);
    if (schema === null) {
        return DataPsmExecutorResultFactory.missingSchema();
    }
    const iri = operation.dataPsmNewIri ?? createNewIdentifier("or");
    const changed = await replaceObjectInSchema(schema.iri, operation.dataPsmChild, iri, reader);
    const result = new DataPsmOr(iri);
    result.dataPsmChoices = [operation.dataPsmChild];
    const changedSchema = changed.some(c => c.iri === schema.iri);
    if (changedSchema) {
        changed.map(c => c.iri === schema.iri ? { ...c, dataPsmParts: c.dataPsmParts = [...c.dataPsmParts, iri] } : c);
    }
    else {
        changed.push({ ...schema, dataPsmParts: schema.dataPsmParts = [...schema.dataPsmParts, iri] });
    }
    return CoreExecutorResult.createSuccess([result], changed, [], new DataPsmWrapWithOrResult(iri));
}
//# sourceMappingURL=data-psm-wrap-with-or-executor.js.map